import {
  IEgdApiClient,
  AdapterCollection,
  UserSettingsForm,
  CustomScheduleAdapter,
  settings,
  StringAdapter,
  DomainSettingsForm,
  SchemaFactory,
  IAuth
} from 'v2/modules/lib'

export interface IQuarantineNotificationFormArgs {
  egdApiClient: IEgdApiClient
  accountId: string
  domainId: number
  userId: string
  auth: IAuth
}

export const QuarantineNotificationForm = ({
  egdApiClient,
  accountId,
  domainId,
  userId,
  auth
}: IQuarantineNotificationFormArgs) => {
  const schema = SchemaFactory.fromSettings([
    settings.allow_override,
    settings.inbound_schedule,
    settings.custom_inbound_schedule
  ])

  const domainSettingsAdapters = AdapterCollection()
  domainSettingsAdapters.add(StringAdapter(settings.allow_override))
  const domainSettingsForm = DomainSettingsForm({
    egdApiClient,
    accountId,
    domainId,
    adapters: domainSettingsAdapters,
    auth
  })

  const userSettingsAdapters = AdapterCollection()
  userSettingsAdapters.add(StringAdapter(settings.inbound_schedule))
  userSettingsAdapters.add(CustomScheduleAdapter(settings.custom_inbound_schedule))

  const userSettingsForm = UserSettingsForm({
    egdApiClient,
    accountId,
    domainId,
    userId,
    adapters: userSettingsAdapters,
    auth
  })

  return { userSettingsForm, domainSettingsForm, schema }
}

export type IQuarantineNotificationForm = ReturnType<typeof QuarantineNotificationForm>
